import { render, staticRenderFns } from "./MoveInMakeBooking.vue?vue&type=template&id=2fb15260&lang=true"
import script from "./MoveInMakeBooking.vue?vue&type=script&lang=js"
export * from "./MoveInMakeBooking.vue?vue&type=script&lang=js"
import style0 from "./MoveInMakeBooking.vue?vue&type=style&index=0&id=2fb15260&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports